import React from 'react';

import styles from '../styles.module.scss';

interface Props {
  backgroundImg: string;
}

export default function NoBenefit({backgroundImg}: Props) {
  return (
    <div
      className={`${styles.noBenefitWrapper} ${
        backgroundImg ? '' : styles.defaults
      }`}
      style={{
        background: ` linear-gradient(90deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0.20) 100%), url(${backgroundImg}) no-repeat center / cover`,
      }}>
      <h3>COMING SOON</h3>
      <div className={styles.pending}>
        새로운 혜택이 <br /> 매달 찾아옵니다.
      </div>
    </div>
  );
}
